import { render, staticRenderFns } from "./BandejaHallazgoRechazados.vue?vue&type=template&id=fea4769a"
import script from "./BandejaHallazgoRechazados.vue?vue&type=script&lang=js"
export * from "./BandejaHallazgoRechazados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports